import { create } from "zustand";
import { allTags, deleteTags, addTag } from "../api_layer/api";

export const useTagsStore = create((set) => ({
    tagsData: [],
    tagLoading: false,
    addTagLoading: false,
    deleteTagLoading:false,
    error: null,
    fetchAllTagData: async () => {
      try {
        set({ tagLoading: true, error: null });
        const response = await allTags();
        set({ tagsData: response.data, tagLoading: false });
      } catch (error) {
        set({ error: error.message, tagLoading: false });
      }
    },
    addTagData: async (payload, setToaster,fetchAllTagData, handleModalClose) => {
      try {
        set({ addTagLoading: true, error: null });
        const response = await addTag(payload);
        setToaster("Tags", "Tags added successfully", "success");
        fetchAllTagData();
        handleModalClose();
        set({ addTagLoading: false });
      } catch (error) {
        handleModalClose();
        setToaster("Tags", "Adding Tag failed", "danger");
        set({ error: error.message, addTagLoading: false });
      }
    },
    deleteTagsData: async (id, setToaster,fetchAllTagData) => {
        try {
          set({ deleteTagLoading: true, error: null });
          const response = await deleteTags(id);
          setToaster("Tags", "Tags deleted successfully", "success");
          fetchAllTagData();
          set({ deleteTagLoading: false });
        } catch (error) {
          setToaster("Tags", "Failed to delete Tag", "success");
          set({ error: error.message, deleteTagLoading: false });
        }
      },
  }));
  